import React from 'react';
import cx from 'classnames';

const DisplayMarkerCircle = (props) => {
    const {isSelected, handleUserMouseEnter, handleUserMouseLeave} = props;
    const {location, image, gender, age, interests, engRate, pos_y, pos_x, tooltip_pos} = props.user;
    const arrowClasses = cx(`${tooltip_pos}-arrow`, "hide", "show@sm");

    const toolTip = isSelected ? (
        <div className={`user-circle-tooltip-${tooltip_pos}`}>
            <h4>User Demographic</h4>
            <div><strong>Gender:</strong> {gender}</div>
            <div><strong>Age:</strong> {age}</div>
            <div><strong>Location:</strong> {location}</div>
            <div><strong>Interests:</strong> {interests}</div>
            <div><strong>Average Engagement Rate:</strong> {engRate}%</div>
            <div className={arrowClasses}></div>
            <div className="up-arrow hide@sm"></div>
        </div>
    ) : null;

    return(
        <div
            className="user-dot"
            key={location}
            style={{top: pos_y, left: pos_x}}
            onMouseEnter={handleUserMouseEnter}
            onMouseLeave={handleUserMouseLeave}>
            <div className="user-dot-circle udc2"></div>
            <div className="user-dot-circle udc1"></div>
            <div className="user-dot-center"></div>
            <div
                className="user-circle-picture"
                style={{backgroundImage: `url(${image})`}}></div>
            {toolTip}
        </div>
    );
};

export default DisplayMarkerCircle;



// WEBPACK FOOTER //
// ./web/js/components/user_demographic_map/display_marker_circle.js